import {
  lightBlue500, lightBlue600, lightBlue700,
  amber400,
  grey100, grey300, grey400, grey500, grey600, grey800,
  white, darkBlack, fullBlack, black,
} from 'material-ui/styles/colors';
import { fade } from 'material-ui/utils/colorManipulator';

export default {
  fontFamily: 'Roboto, sans-serif',
  palette: {
    primary1Color: darkBlack,
    primary2Color: darkBlack,
    primary3Color: grey400,
    accent1Color: lightBlue500,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: lightBlue500,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
  },
  appBar: {
    color: black,
    height: 48,
  },
  CustomFlatButtonStyle: {
    border: '1px solid',
    primaryTextColor: lightBlue500,
    secondaryTextColor: grey100,
  },
  CustomSelectItemNavBar: {
    underlineStyle: {
      display: 'none',
    },
    underlineDisabledStyle: {
      display: 'none',
    },
    style: {
      width: 140,
      paddingLeft: 5,
      height: 48,
      verticalAlign: 'middle',
    },
    labelStyle: {
      color: white,
    },
  },
  CustomIconNavBar: {
    color: white,
  },
  CustomSideBar: {
    active: {
      color: lightBlue600,
    },
    inactive: {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    font: {
      fontSize: 14,
      fontWeight: 500,
    },
    icon: {
      fontSize: 16,
    },
    backgroundColor: '#fafafa',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 1px, rgba(0, 0, 0, 0.23) 0px 3px 9px',
  },
  textField: {
    disabledTextColor: grey600,
  },
};



// WEBPACK FOOTER //
// ./src/helpers/muiTheme/index.js